/* MUI */
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/* Components */
import { KPICard } from '../../internal/KPICard';

export const SummaryCard = ({
    totalAccounts,
    sharedAccounts,
    workAccounts,
    personalAccounts,
    serviceAccounts
}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const accounts = {
        personalAccounts,
        serviceAccounts,
        sharedAccounts,
        workAccounts
    };

    return (
        <Box
            data-testid="accountsReportSummaryCard"
            sx={{
                backgroundColor: 'background.reportSummaryCardLight',
                flexFlow: 'wrap'
            }}
            display="flex"
            width="100%"
        >
            <Box flex={1} m="24px">
                <KPICard
                    backgroundColor={
                        theme?.palette.background.reportSummaryCardDark
                    }
                    bigNumber
                    number={totalAccounts}
                    textColor={theme?.palette.text.reportSummaryCardLight}
                    title={t('Reports.AccountsInventory.total')}
                />
            </Box>
            <Box flex={4} display="flex" m="24px">
                {Object.entries(accounts).map(([key, value]) => (
                    <Box flex={1} key={key}>
                        <KPICard
                            backgroundColor={
                                theme?.palette.background.reportSummaryCardLight
                            }
                            bigNumber
                            number={value}
                            textColor={
                                theme?.palette.text.reportSummaryCardDark
                            }
                            title={t(`Reports.AccountsInventory.${key}`)}
                        />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
